export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si ves esto, el formulario no se recibió (pero no deberías verlo)"])}
}